export default __webpack_public_path__ + "static/media/InsideMuscles_05.ed573f98.png";